const QUESTIONS = [
    "최근에 가장 미안함을 느꼈던 사람은 누구인가요?",
    "본인이 가장 무서워하는 것은 무엇인가요?",
    "지금 본인의 가장 큰 문제는 무엇이라고 생각하나요?",
    "받았던 상처 중 아직 아물지 않은 상처가 있나요?",
    "지금 본인의 삶에서 사라지기를 바라는 것이 있나요?",
    "힘들 때 주로 무엇을 하나요?",
    "최근 본인에 대해 새롭게 알게 된 모습이 있나요?",
    "상처를 극복하는 나만의 방법은 무엇인가요?",
    "살면서 가장 용기를 냈던 때는 언제인가요?",
    "본인의 삶을 지탱하는 것이 있나요?",
    "10년 후 나의 모습은 어떨 것 같나요?",
    "스스로 가치 있다고 느낀 순간은 언제인가요?"
];

export { QUESTIONS };